export default "__VITE_ASSET__CwIE2xfj__"